// extracted by mini-css-extract-plugin
export default {"desc":"ManageGeofenceStyle_desc__jOndx"};